import React from 'react'
import { useTranslation } from 'react-i18next'
import { Typography, Box, Chip } from '@mui/material'
import HsChipList from '../../mailTemplate/src/components/atomic/molecules/HsChipList'

const getStatusConfig = (status, t) => {
  const configs = {
    SUBMITTED: { label: t('mailTemplate.campaigns.status.SUBMITTED'), color: 'primary', bgColor: '#e3f2fd' },
    PREPARING: { label: t('mailTemplate.campaigns.status.PREPARING'), color: 'warning', bgColor: '#fff3e0' },
    READY_TO_SELECT: { label: t('mailTemplate.campaigns.status.READY_TO_SELECT'), color: 'info', bgColor: '#e1f5fe' },
    CONTACTS_SEARCHING: { label: t('mailTemplate.campaigns.status.CONTACTS_SEARCHING'), color: 'default', bgColor: '#e0f2f1', customColor: '#00897b' },
    CONTACTS_FOUND: { label: t('mailTemplate.campaigns.status.CONTACTS_FOUND'), color: 'default', bgColor: '#e0f2f1', customColor: '#00897b' },
    GENERATING: { label: t('mailTemplate.campaigns.status.GENERATING'), color: 'info', bgColor: '#e3f2fd' },
    READY_TO_MAIL: { label: t('mailTemplate.campaigns.status.READY_TO_MAIL'), color: 'success', bgColor: '#e8f5e8' },
    MAILING: { label: t('mailTemplate.campaigns.status.MAILING'), color: 'secondary', bgColor: '#f3e5f5' },
    FAILED: { label: t('mailTemplate.campaigns.status.FAILED'), color: 'error', bgColor: '#ffebee' }
  }
  return configs[status] || null
}

const CampaignInfo = ({ campaignDetails, currentStatus }) => {
  const { t } = useTranslation()

  const statusConfig = getStatusConfig(currentStatus, t)

  if (!campaignDetails) return null

  return (
    <Box sx={{ display: 'flex', gap: 2, flexDirection: 'column' }}>
      {statusConfig && (
        <Box sx={{ flex: 1 }}>
          <Typography
            variant='body2'
            sx={{
              color: 'text.primary',
              fontWeight: 600,
              mb: 1.5,
              textAlign: 'center'
            }}
          >
            {t('mailTemplate.campaigns.status.label')}
          </Typography>
          <Box sx={{ display: 'flex', justifyContent: 'center' }}>
            <Chip
              label={statusConfig.label}
              color={statusConfig.customColor ? 'default' : statusConfig.color}
              size="small"
              sx={{
                fontWeight: 500,
                borderRadius: 1.5,
                height: 20,
                ...(statusConfig.customColor && {
                  backgroundColor: statusConfig.customColor,
                  color: '#fff'
                })
              }}
            />
          </Box>
        </Box>
      )}

      {campaignDetails?.hsCodes?.length > 0 && (
        <Box sx={{ flex: 1 }}>
          <Typography
            variant='body2'
            sx={{
              color: 'text.primary',
              fontWeight: 600,
              mb: 1.5,
              textAlign: 'center'
            }}
          >
            {t('personnel.marketChanges.hsCodes')}
          </Typography>
          <Box sx={{
            display: 'flex',
            gap: 1,
            justifyContent: 'center'
          }}>
            <HsChipList hsArr={campaignDetails?.hsCodes} visibleCount={3}/>
          </Box>
        </Box>
      )}
    </Box>
  )
}

export default CampaignInfo
